import { css } from '@emotion/react';
import { SelectHTMLAttributes } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAddressFormBusinessLogic } from '../context/use-address-form';
import { MetaAddressFormFields } from '../types';

export interface HiddenSelectInputProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: keyof MetaAddressFormFields;
  values: string[];
}

export const HiddenSelectInput: React.FC<HiddenSelectInputProps> = ({ name, values, ...props }) => {
  const { register } = useFormContext<MetaAddressFormFields>();
  const { addressFormLayout } = useAddressFormBusinessLogic();
  const hasCountryField = addressFormLayout.some(field => field.name === 'country');

  if (!hasCountryField) {
    return null;
  }

  return (
    <select {...props} {...register(name)} css={styles.hiddenInput}>
      {values.map(value => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </select>
  );
};

const styles = {
  hiddenInput: css({
    // hide select input from viewport
    position: 'absolute',
    zIndex: -99999,
    height: '1px',
    width: '1px',
    left: '-100px',
    opacity: 0,
    padding: 0,
    border: 'none',
  }),
};
